// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/patients/modules/patients-detail/components/edit-patient/edit-patient.less
// module id = 3773
// module chunks = 0